import type { RouteObject } from 'react-router';
import { RolesPage } from './pages/RolesPage';

export const ROLE_ROUTES: RouteObject[] = [{ path: 'roles', element: <RolesPage /> }];
